import { render } from "./New_searchByCharacteristic.vue?vue&type=template&id=9b808072"
import script from "./New_searchByCharacteristic.vue?vue&type=script&lang=js"
export * from "./New_searchByCharacteristic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__